var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.6953 14.8059H7.98064M10.8855 20.4865H7.98064M19.6001 9.12521H7.98064M25.4099 8.84118V23.6108C25.4099 25.9969 25.4099 27.19 24.935 28.1013C24.5172 28.903 23.8506 29.5548 23.0307 29.9632C22.0987 30.4276 20.8785 30.4276 18.4382 30.4276H9.14259C6.70227 30.4276 5.48211 30.4276 4.55003 29.9632C3.73015 29.5548 3.06357 28.903 2.64582 28.1013C2.1709 27.19 2.1709 25.9969 2.1709 23.6108V8.84118C2.1709 6.45509 2.1709 5.26204 2.64582 4.35068C3.06357 3.54902 3.73015 2.89724 4.55003 2.48878C5.48211 2.02441 6.70227 2.02441 9.14259 2.02441H18.4382C20.8785 2.02441 22.0987 2.02441 23.0307 2.48878C23.8506 2.89724 24.5172 3.54902 24.935 4.35068C25.4099 5.26204 25.4099 6.45509 25.4099 8.84118Z",
    stroke: "currentColor",
    strokeWidth: 2.58211,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/icon_text.7b9d25e9.svg";
export { ForwardRef as ReactComponent };